<template>
    <div class="page-title mb-4">
        <h1 class="headline indigo--text text--darken-1">
            <v-icon medium color="indigo darken-1">{{ icon }}</v-icon>
            {{ main }}
        </h1>
        <h2 class="subheading indigo--text text--darken-1 ma-0 mb-2 pa-0">{{ sub }}</h2>
        <hr>
    </div>
</template>

<script>
export default {
    name: 'PageTitle',
    props: ['icon', 'main', 'sub']
}
</script>

<style>
</style>
